/**
 * COMMERCE-WORKSPACE-FRAMEWORK-000001 — toolbar selects shared with PlatformDataGrid.
 */
import type { SellerConnection } from '../api/amazonconnect';
import type { ToolbarSelectOption } from './types';

const labelClass = 'text-xs font-medium text-slate-500';
const selectClass =
  'mt-1 block min-h-11 min-w-[10rem] rounded-lg border border-slate-300 px-2 text-sm dark:border-slate-600 dark:bg-slate-900';

export function ConnectionToolbarSelect({
  connections,
  value,
  onChange,
}: {
  connections: SellerConnection[];
  value: string;
  onChange: (connectionId: string) => void;
}) {
  return (
    <label className="text-sm">
      <span className={labelClass}>Connection</span>
      <select
        className={`${selectClass} min-w-[16rem]`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {connections.length === 0 && <option value="">No connections</option>}
        {connections.map((c) => (
          <option key={c.id} value={c.id}>
            {c.seller_ref || c.id.slice(0, 8)} · {c.status}
          </option>
        ))}
      </select>
    </label>
  );
}

export function ToolbarFilterSelect({
  label,
  value,
  options,
  onChange,
  minWidthClass = 'min-w-[10rem]',
}: {
  label: string;
  value: string;
  options: ToolbarSelectOption[];
  onChange: (value: string) => void;
  minWidthClass?: string;
}) {
  return (
    <label className="text-sm">
      <span className={labelClass}>{label}</span>
      <select
        className={`${selectClass} ${minWidthClass}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((o) => (
          <option key={o.value || 'all'} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
